/**
 * API/Functions Abstraction Layer — Entry Point
 * Sprint 1, Story 1.3 / Updated Sprint 4, Story 4.7
 *
 * Toggle: change the import below to switch between Supabase and Express.
 * - Express (self-hosted): fetch('/api/...')
 */

export type { ApiClient, ApiResult, ApiInvokeOptions } from './types';
export { expressApiAdapter } from './express-adapter';

import { expressApiAdapter } from './express-adapter';
import type { ApiClient } from './types';

// ─── Active API Client ────────────────────────────────────────────────
export const api: ApiClient = expressApiAdapter;
